import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gtapp-grouped-job-types',
  standalone: false,
  templateUrl: './grouped-job-types.component.html',
  styleUrl: './grouped-job-types.component.scss',
})
export class GroupedJobTypesComponent implements OnInit {
  uiTabs = {
    tab10: 'Response Types',
    tab11: 'Service Types',
    tab12: 'Incident Types',
  };
  selectedTab = this.uiTabs.tab10;
  ngOnInit(): void {
    const savedTab = sessionStorage.getItem('selectedTab');
    if (savedTab) {
      this.changeTab(savedTab);
    }
  }

  changeTab(tab: any) {
    if (Object.values(this.uiTabs)?.includes(tab)) {
      this.selectedTab = tab;

      sessionStorage.setItem('selectedTab', tab);
    }
  }
}
